// extracted by mini-css-extract-plugin
module.exports = {"menu__list":"AuthMenu_menu__list__14wCP"};